module.exports = __webpack_public_path__ + "img/info-icon.3942d5ae.svg";